<template>
  <div>
    <button class="tut-btn" @click="abrir = true">
      <fa-icon icon="info-circle" /> Tutorial
    </button>

    <div v-if="abrir" class="tut-overlay" @click.self="abrir = false">
      <div class="tut-modal">
        <div class="tut-header">
          <span class="tut-title">Fórmulas e Regras</span>
          <button class="tut-close" @click="abrir = false"><fa-icon icon="times" /></button>
        </div>

        <div class="tut-tabs">
          <button
            v-for="(s, i) in secoes"
            :key="i"
            class="tut-tab"
            :class="{ 'tut-tab-active': secaoAtiva === i }"
            @click="secaoAtiva = i"
          >
            <fa-icon :icon="s.icone" class="tut-tab-icon" />
            {{ s.titulo }}
          </button>
        </div>

        <div class="tut-body">
          <!-- COMPONENTES -->
          <div v-if="secaoAtiva === 0">
            <p class="tut-desc">Arraste ou clique nos componentes do painel esquerdo para montar a fórmula.</p>

            <div class="tut-card">
              <div class="tut-card-title">Variáveis do sistema</div>
              <div class="tut-card-desc">Dados que vêm do pedido/produto. Cada tipo tem uma cor:</div>
              <div class="tut-legend">
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-valor">PC</span>
                  <span>Valor <small>(verde)</small></span>
                </div>
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-perc">PC</span>
                  <span>Percentual <small>(laranja)</small></span>
                </div>
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-qtd">QU</span>
                  <span>Quantidade <small>(azul)</small></span>
                </div>
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-fator">FA</span>
                  <span>Fator <small>(roxo)</small></span>
                </div>
              </div>
            </div>

            <div class="tut-card">
              <div class="tut-card-title">Operadores</div>
              <div class="tut-ops">
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">+</span> Soma</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&minus;</span> Subtração</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&times;</span> Multiplicação</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&divide;</span> Divisão</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-paren">(</span><span class="tut-mini-node tut-n-paren">)</span> Parênteses</div>
              </div>
            </div>

            <div class="tut-card">
              <div class="tut-card-title">Valor fixo e Resultados</div>
              <div class="tut-legend">
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-num">0</span>
                  <span>Valor fixo — arraste e edite o número no canvas</span>
                </div>
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-result">E1</span>
                  <span>Resultado de etapa anterior — use em etapas seguintes</span>
                </div>
              </div>
            </div>
          </div>

          <!-- COMO FUNCIONA -->
          <div v-if="secaoAtiva === 1">
            <p class="tut-desc">Cada etapa calcula um resultado. Etapas posteriores podem usar resultados anteriores.</p>

            <div class="tut-card">
              <div class="tut-card-title">Estrutura de uma etapa</div>
              <div class="tut-flow-demo">
                <div class="tut-flow-row">
                  <span class="tut-mini-node tut-n-result">50</span>
                  <span class="tut-wire"></span>
                  <span class="tut-mini-node tut-n-eq">=</span>
                  <span class="tut-wire"></span>
                  <span class="tut-mini-node tut-n-valor">PC</span>
                  <span class="tut-wire-zone"></span>
                  <span class="tut-mini-node tut-n-op">+</span>
                  <span class="tut-wire-zone"></span>
                  <span class="tut-mini-node tut-n-perc">CM</span>
                </div>
                <div class="tut-flow-labels">
                  <span>resultado</span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span>Preço Custo</span>
                  <span></span>
                  <span>Soma</span>
                  <span></span>
                  <span>Perc. CMV</span>
                </div>
              </div>
              <div class="tut-card-desc">O resultado fica à esquerda do <strong>=</strong>. A expressão fica à direita, composta por variáveis, operadores e valores fixos conectados.</div>
            </div>

            <div class="tut-card">
              <div class="tut-card-title">Encadeando etapas</div>
              <div class="tut-chain">
                <div class="tut-chain-step">
                  <span class="tut-chain-num">1</span>
                  <div class="tut-chain-body">
                    <span class="tut-mini-node tut-n-result" title="total_desc">TD</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-eq">=</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-perc" title="desc_erp">DE</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-op">+</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-perc" title="desc_tabela">DT</span>
                  </div>
                </div>
                <div class="tut-chain-wire"></div>
                <div class="tut-chain-step">
                  <span class="tut-chain-num">2</span>
                  <div class="tut-chain-body">
                    <span class="tut-mini-node tut-n-result" title="preco_liq">PL</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-eq">=</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-valor" title="preco">PR</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-op">&times;</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-paren">(</span>
                    <span class="tut-mini-node tut-n-num">1</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-op">&minus;</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-ref" title="total_desc (etapa 1)">TD</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-op">&divide;</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-num">100</span>
                    <span class="tut-mini-node tut-n-paren">)</span>
                  </div>
                </div>
                <div class="tut-chain-wire"></div>
                <div class="tut-chain-step tut-chain-final">
                  <span class="tut-chain-num">3</span>
                  <div class="tut-chain-body">
                    <span class="tut-mini-node tut-n-result" title="margem" style="border-color: #a7f3d0; background: linear-gradient(135deg, #ecfdf5, #d1fae5); color: #059669;">MA</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-eq">=</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-paren">(</span>
                    <span class="tut-mini-node tut-n-ref" title="preco_liq (etapa 2)">PL</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-op">&minus;</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-valor" title="preco_custo">PC</span>
                    <span class="tut-mini-node tut-n-paren">)</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-op">&divide;</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-ref" title="preco_liq (etapa 2)">PL</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-op">&times;</span>
                    <span class="tut-wire"></span>
                    <span class="tut-mini-node tut-n-num">100</span>
                  </div>
                </div>
              </div>
              <div class="tut-card-desc">O resultado da última etapa é o <strong>valor final</strong> da fórmula. Cards <span class="tut-mini-node tut-n-ref" style="width:auto;height:auto;padding:1px 5px;font-size:0.55rem;">TD</span> em roxo indicam resultados de etapas anteriores.</div>
            </div>
          </div>

          <!-- EXEMPLOS -->
          <div v-if="secaoAtiva === 2">
            <p class="tut-desc">Exemplos reais de fórmulas de margem. Clique para ver outros.</p>

            <div class="tut-card">
              <div class="tut-card-title tut-card-title-row">
                <span>{{ exemploAtivo.nome }}</span>
                <button class="tut-shuffle" @click="sortearExemplo">
                  <fa-icon icon="sync" /> Outro exemplo
                </button>
              </div>
              <div class="tut-example-lines">
                <div
                  v-for="(linha, i) in exemploAtivo.linhas"
                  :key="i"
                  class="tut-example-line"
                  :class="{ 'tut-example-final': i === exemploAtivo.linhas.length - 1 }"
                >
                  <div class="tut-node-row">
                    <div class="tut-node tut-node-result" :title="linha.resultado">{{ getInitials(linha.resultado) }}</div>
                    <div class="tut-wire"></div>
                    <div class="tut-node tut-node-eq">=</div>
                    <div class="tut-wire"></div>
                    <template v-for="(tk, ti) in tokenizar(linha.expressao)">
                      <div :key="ti" class="tut-node" :class="tutNodeClass(tk)" :title="tutNodeTitle(tk)">{{ tutNodeLabel(tk) }}</div>
                      <div v-if="ti < tokenizar(linha.expressao).length - 1" :key="'w'+ti" class="tut-wire"></div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="tut-example-result">
                <fa-icon icon="check-circle" class="tut-example-check" />
                Resultado final: <strong>{{ exemploAtivo.resultadoFinal }}</strong>
              </div>
            </div>
          </div>

          <!-- REGRAS -->
          <div v-if="secaoAtiva === 3">
            <p class="tut-desc">Regras condicionais alteram valores de variáveis <strong>antes</strong> do cálculo, sem modificar a fórmula.</p>

            <div class="tut-card">
              <div class="tut-card-title">Como funcionam</div>
              <div class="tut-card-desc">Cada regra segue a lógica <strong>SE</strong> condição <strong>ENTÃO</strong> sobrescreve valor:</div>
              <div class="tut-rule-demo">
                <div class="tut-rule-row">
                  <span class="tut-rule-tag tut-rule-if">SE</span>
                  <span class="tut-rule-pill tut-rule-pill-field">Descrição Tipo Frete</span>
                  <span class="tut-rule-pill tut-rule-pill-op">contém</span>
                  <span class="tut-rule-pill tut-rule-pill-val">FOB</span>
                </div>
                <div class="tut-rule-arrow"><fa-icon icon="arrow-down" /></div>
                <div class="tut-rule-row">
                  <span class="tut-rule-tag tut-rule-then">ENTÃO</span>
                  <span class="tut-rule-pill tut-rule-pill-var">Valor Frete Pedido</span>
                  <span class="tut-rule-eq">=</span>
                  <span class="tut-rule-pill tut-rule-pill-override">0</span>
                </div>
              </div>
              <div class="tut-card-desc">Neste exemplo, quando o tipo de frete for FOB, o valor do frete é substituído por 0 antes de entrar no cálculo.</div>
            </div>

            <div class="tut-card">
              <div class="tut-card-title">Campos de condição</div>
              <div class="tut-card-desc">As condições usam <strong>campos de contexto</strong> — dados do pedido que não entram na fórmula, mas influenciam os valores:</div>
              <div class="tut-legend" style="margin-top: 8px;">
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-ctx">DF</span>
                  <span>Descrição Tipo Frete <small>(texto do frete selecionado)</small></span>
                </div>
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-ctx">IF</span>
                  <span>ID Tipo Frete <small>(código numérico)</small></span>
                </div>
                <div class="tut-legend-item">
                  <span class="tut-mini-node tut-n-ctx">IP</span>
                  <span>ID Plano Pagamento <small>(código numérico)</small></span>
                </div>
              </div>
            </div>

            <div class="tut-card">
              <div class="tut-card-title">Operadores disponíveis</div>
              <div class="tut-ops">
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">=</span> igual a</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&ne;</span> diferente</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&sup;</span> contém</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&nsup;</span> não contém</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&gt;</span> maior</div>
                <div class="tut-op-item"><span class="tut-mini-node tut-n-op">&lt;</span> menor</div>
              </div>
              <div class="tut-card-desc">Para campos de texto, use <strong>contém</strong> ou <strong>igual</strong>. Para IDs numéricos, use <strong>igual</strong>, <strong>maior</strong> ou <strong>menor</strong>. A comparação de texto ignora maiúsculas/minúsculas.</div>
            </div>

            <div class="tut-card">
              <div class="tut-card-title">Múltiplas regras</div>
              <div class="tut-card-desc">Você pode criar várias regras na mesma fórmula. Todas são avaliadas em ordem — regras diferentes podem sobrescrever variáveis diferentes. Use o botão de olho para ativar/desativar regras sem excluí-las.</div>
            </div>
          </div>

          <!-- DICAS -->
          <div v-if="secaoAtiva === 4">
            <div class="tut-tips">
              <div class="tut-tip">
                <div class="tut-tip-icon"><fa-icon icon="hand-pointer" /></div>
                <div>
                  <strong>Inserir componentes</strong>
                  <p>Clique no <strong>+</strong> da linha e depois na variável/operador. Ou arraste direto do painel.</p>
                </div>
              </div>
              <div class="tut-tip">
                <div class="tut-tip-icon"><fa-icon icon="pencil-alt" /></div>
                <div>
                  <strong>Renomear etapas</strong>
                  <p>Clique no nome abaixo do resultado para dar um nome descritivo à etapa.</p>
                </div>
              </div>
              <div class="tut-tip">
                <div class="tut-tip-icon"><fa-icon icon="sliders-h" /></div>
                <div>
                  <strong>Simulador ao vivo</strong>
                  <p>Altere os valores no painel direito para testar cenários. O resultado atualiza em tempo real.</p>
                </div>
              </div>
              <div class="tut-tip">
                <div class="tut-tip-icon"><fa-icon icon="lock" /></div>
                <div>
                  <strong>Proteção contra erros</strong>
                  <p>Fórmulas com divisão por zero ou variáveis inexistentes não podem ser salvas.</p>
                </div>
              </div>
              <div class="tut-tip">
                <div class="tut-tip-icon"><fa-icon icon="sync" /></div>
                <div>
                  <strong>Reverter alterações</strong>
                  <p>Se fez algo errado, clique em <strong>Reverter</strong> para voltar à versão salva.</p>
                </div>
              </div>
              <div class="tut-tip">
                <div class="tut-tip-icon"><fa-icon icon="exchange-alt" /></div>
                <div>
                  <strong>Uma ativa por sistema</strong>
                  <p>Ao ativar uma fórmula, a anterior para o mesmo sistema é desativada automaticamente.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const EXEMPLOS = [
  {
    nome: "Padrão CMV",
    resultadoFinal: "percentual_lucro",
    linhas: [
      { resultado: "cmv_perc", expressao: "preco_com_imposto * perc_cmv / 100" },
      { resultado: "cmv_comissao", expressao: "preco_com_imposto * perc_comissao / 100" },
      { resultado: "cmv_total", expressao: "preco_custo + cmv_perc + cmv_comissao" },
      { resultado: "percentual_lucro", expressao: "(1 - cmv_total / preco_com_imposto) * 100" },
    ],
  },
  {
    nome: "Simplificado",
    resultadoFinal: "margem",
    linhas: [
      { resultado: "custo", expressao: "preco_custo + (preco * (perc_cmv + perc_comissao) / 100)" },
      { resultado: "margem", expressao: "(1 - custo / preco) * 100" },
    ],
  },
  {
    nome: "Com taxa fixa",
    resultadoFinal: "lucro_final",
    linhas: [
      { resultado: "pis", expressao: "1.65" },
      { resultado: "cofins", expressao: "7.60" },
      { resultado: "impostos", expressao: "(pis + cofins) / 100 * preco" },
      { resultado: "cmv", expressao: "preco_custo + impostos + (preco * perc_comissao / 100)" },
      { resultado: "lucro_final", expressao: "(1 - cmv / preco) * 100" },
    ],
  },
];

export default {
  name: "TutorialFormula",
  data() {
    return {
      abrir: false,
      secaoAtiva: 0,
      exemploIndex: 0,
      secoes: [
        { titulo: "Componentes", icone: "th" },
        { titulo: "Como funciona", icone: "sitemap" },
        { titulo: "Exemplos", icone: "file-code" },
        { titulo: "Regras", icone: "filter" },
        { titulo: "Dicas", icone: "magic" },
      ],
    };
  },
  computed: {
    exemploAtivo() {
      return EXEMPLOS[this.exemploIndex];
    },
  },
  methods: {
    sortearExemplo() {
      let novo;
      do {
        novo = Math.floor(Math.random() * EXEMPLOS.length);
      } while (novo === this.exemploIndex && EXEMPLOS.length > 1);
      this.exemploIndex = novo;
    },
    tokenizar(expr) {
      if (!expr) return [];
      const tokens = [];
      let pos = 0;
      const len = expr.length;
      while (pos < len) {
        const ch = expr[pos];
        if (/\s/.test(ch)) { pos++; continue; }
        if ("()".includes(ch)) { tokens.push({ tipo: "paren", val: ch }); pos++; continue; }
        if ("+-*/".includes(ch)) { tokens.push({ tipo: "op", val: ch }); pos++; continue; }
        if (/[\d.]/.test(ch)) {
          let n = "";
          while (pos < len && /[\d.]/.test(expr[pos])) { n += expr[pos]; pos++; }
          tokens.push({ tipo: "num", val: n });
          continue;
        }
        if (/[a-zA-Z_]/.test(ch)) {
          let v = "";
          while (pos < len && /[a-zA-Z0-9_]/.test(expr[pos])) { v += expr[pos]; pos++; }
          tokens.push({ tipo: "var", val: v });
          continue;
        }
        pos++;
      }
      return tokens;
    },
    tutNodeClass(tk) {
      if (tk.tipo === "var") return "tut-node-var";
      if (tk.tipo === "op") return "tut-node-op";
      if (tk.tipo === "num") return "tut-node-num";
      if (tk.tipo === "paren") return "tut-node-paren";
      return "";
    },
    tutNodeLabel(tk) {
      if (tk.tipo === "op") return { "+": "+", "-": "−", "*": "×", "/": "÷" }[tk.val] || tk.val;
      if (tk.tipo === "var") return this.getInitials(tk.val);
      return tk.val;
    },
    tutNodeTitle(tk) {
      if (tk.tipo === "var") return tk.val.replace(/_/g, " ");
      if (tk.tipo === "op") return { "+": "Soma", "-": "Subtração", "*": "Multiplicação", "/": "Divisão" }[tk.val] || tk.val;
      if (tk.tipo === "num") return "Valor " + tk.val;
      return tk.val;
    },
    getInitials(nome) {
      const words = nome.replace(/_/g, " ").split(/\s+/).filter(Boolean);
      const stops = ["de", "do", "da", "dos", "das"];
      const meaningful = words.filter((w) => !stops.includes(w.toLowerCase()));
      if (meaningful.length >= 2) return (meaningful[0][0] + meaningful[1][0]).toUpperCase();
      if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
      return nome.substring(0, 2).toUpperCase();
    },
  },
};
</script>

<style scoped>
/* TRIGGER BUTTON */
.tut-btn {
  padding: 6px 12px; border: 1px solid #d1d5db;
  border-radius: 8px; background: #fff;
  color: #6b7280; font-size: 0.76rem; font-weight: 500;
  cursor: pointer; display: flex; align-items: center; gap: 5px;
  transition: all 0.15s;
}
.tut-btn:hover { border-color: #818cf8; color: #6366f1; }

/* OVERLAY */
.tut-overlay {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.5); z-index: 1050;
  display: flex; align-items: center; justify-content: center;
  backdrop-filter: blur(4px);
}

/* MODAL */
.tut-modal {
  background: #fff; border-radius: 16px;
  width: 620px; max-width: 92vw; max-height: 82vh;
  overflow: hidden; display: flex; flex-direction: column;
  box-shadow: 0 25px 60px rgba(0,0,0,0.2);
}

/* HEADER */
.tut-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 20px; border-bottom: 1px solid #f3f4f6;
}
.tut-title { font-size: 0.95rem; font-weight: 700; color: #1f2937; }
.tut-close {
  width: 30px; height: 30px; border-radius: 8px; border: none;
  background: #f3f4f6; color: #6b7280; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; transition: all 0.15s;
}
.tut-close:hover { background: #fee2e2; color: #dc2626; }

/* TABS */
.tut-tabs {
  display: flex; gap: 4px; padding: 10px 20px 0;
  border-bottom: 1px solid #f3f4f6;
}
.tut-tab {
  padding: 8px 14px; border: none; border-bottom: 2px solid transparent;
  background: none; color: #9ca3af; font-size: 0.76rem; font-weight: 600;
  cursor: pointer; display: flex; align-items: center; gap: 6px;
  transition: all 0.15s; margin-bottom: -1px;
}
.tut-tab:hover { color: #6366f1; }
.tut-tab-active { color: #6366f1; border-bottom-color: #6366f1; }
.tut-tab-icon { font-size: 0.7rem; }

/* BODY */
.tut-body {
  padding: 20px; overflow-y: auto; flex: 1;
}
.tut-desc { color: #6b7280; font-size: 0.8rem; margin: 0 0 14px; line-height: 1.5; }

/* CARD */
.tut-card {
  background: #f9fafb; border: 1px solid #e5e7eb;
  border-radius: 12px; padding: 14px 16px; margin-bottom: 12px;
}
.tut-card-title {
  font-weight: 700; font-size: 0.8rem; color: #1f2937; margin-bottom: 8px;
}
.tut-card-title-row {
  display: flex; justify-content: space-between; align-items: center;
}
.tut-card-desc { font-size: 0.75rem; color: #6b7280; margin-top: 8px; line-height: 1.5; }

/* MINI NODES (visual language do editor) */
.tut-mini-node {
  display: inline-flex; align-items: center; justify-content: center;
  width: 32px; height: 32px; border-radius: 8px;
  font-size: 0.65rem; font-weight: 800; flex-shrink: 0;
  border: 1.5px solid #e5e7eb; background: #fff;
}
.tut-n-valor { border-color: #a7f3d0; background: linear-gradient(135deg, #ecfdf5, #d1fae5); color: #065f46; }
.tut-n-perc { border-color: #fdba74; background: linear-gradient(135deg, #fff7ed, #ffedd5); color: #9a3412; }
.tut-n-qtd { border-color: #93c5fd; background: linear-gradient(135deg, #eff6ff, #dbeafe); color: #1e40af; }
.tut-n-fator { border-color: #c4b5fd; background: linear-gradient(135deg, #f5f3ff, #ede9fe); color: #5b21b6; }
.tut-n-op { border-color: #ddd6fe; background: linear-gradient(135deg, #f5f3ff, #ede9fe); color: #7c3aed; font-size: 0.9rem; }
.tut-n-num { border-color: #fde68a; background: linear-gradient(135deg, #fefce8, #fef3c7); color: #92400e; font-family: 'SF Mono', monospace; }
.tut-n-paren { border-color: #d1d5db; background: #f9fafb; color: #9ca3af; width: 24px; font-size: 0.9rem; font-weight: 400; }
.tut-n-result { border-color: #c7d2fe; background: linear-gradient(135deg, #eef2ff, #e0e7ff); color: #4f46e5; }
.tut-n-ref { border-color: #c4b5fd; background: linear-gradient(135deg, #f5f3ff, #ede9fe); color: #6d28d9; }
.tut-n-eq { border-color: #d1d5db; background: #f9fafb; color: #9ca3af; width: 28px; font-size: 0.85rem; font-weight: 700; }

/* LEGEND */
.tut-legend { display: flex; flex-direction: column; gap: 6px; margin-top: 6px; }
.tut-legend-item {
  display: flex; align-items: center; gap: 10px;
  font-size: 0.75rem; color: #374151;
}
.tut-legend-item small { color: #9ca3af; }

/* OPERATORS */
.tut-ops {
  display: flex; flex-wrap: wrap; gap: 8px; margin-top: 6px;
}
.tut-op-item {
  display: flex; align-items: center; gap: 6px;
  font-size: 0.72rem; color: #374151;
}

/* FLOW DEMO */
.tut-flow-demo {
  background: #fff; border: 1px solid #e5e7eb; border-radius: 10px;
  padding: 14px 16px; margin: 8px 0;
}
.tut-flow-row {
  display: flex; align-items: center; justify-content: center; gap: 0;
}
.tut-flow-labels {
  display: flex; align-items: center; justify-content: center; gap: 0;
  margin-top: 4px;
}
.tut-flow-labels span {
  width: 32px; text-align: center; font-size: 0.5rem; color: #9ca3af;
  flex-shrink: 0;
}
.tut-flow-labels span:nth-child(5), .tut-flow-labels span:nth-child(7), .tut-flow-labels span:nth-child(9) {
  width: 52px;
}
.tut-wire {
  width: 16px; height: 1.5px; background: #d1d5db; flex-shrink: 0;
}
.tut-wire-zone {
  width: 20px; height: 1.5px; background: #d1d5db; flex-shrink: 0;
}

/* CHAIN (etapas encadeadas) */
.tut-chain { display: flex; flex-direction: column; align-items: stretch; gap: 0; }
.tut-chain-step {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 6px; border-radius: 10px; transition: background 0.15s;
}
.tut-chain-step:hover { background: #f8fafc; }
.tut-chain-final { background: #f0fdf4; border: 1.5px solid #bbf7d0; border-radius: 10px; }
.tut-chain-final:hover { background: #ecfdf5; }
.tut-chain-num {
  width: 22px; height: 22px; display: inline-flex;
  align-items: center; justify-content: center;
  background: #6366f1; color: #fff; border-radius: 7px;
  font-size: 0.6rem; font-weight: 700; flex-shrink: 0;
}
.tut-chain-final .tut-chain-num { background: #059669; }
.tut-chain-body {
  display: flex; align-items: center; gap: 0; flex-wrap: wrap;
}
.tut-chain-wire {
  width: 1.5px; height: 8px; background: #d1d5db; margin-left: 20px;
}

/* EXAMPLES */
.tut-shuffle {
  padding: 4px 10px; border: 1px solid #c7d2fe; border-radius: 8px;
  background: #fff; color: #6366f1; font-size: 0.7rem; font-weight: 600;
  cursor: pointer; display: flex; align-items: center; gap: 4px;
  transition: all 0.15s;
}
.tut-shuffle:hover { background: #eef2ff; }
.tut-example-lines { display: flex; flex-direction: column; gap: 4px; align-items: center; }
.tut-example-line { padding: 4px 0; }
.tut-example-final .tut-node-result { border-color: #a7f3d0; background: linear-gradient(135deg, #ecfdf5, #d1fae5); color: #059669; }

.tut-node-row { display: flex; align-items: center; flex-wrap: wrap; justify-content: center; }
.tut-node {
  width: 32px; height: 32px; border-radius: 7px;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.45rem; font-weight: 700; flex-shrink: 0;
  border: 1.5px solid #e5e7eb; background: #fff; color: #374151;
  text-align: center; overflow: hidden; padding: 2px;
}
.tut-node-result {
  border-color: #c7d2fe; background: linear-gradient(135deg, #eef2ff, #e0e7ff);
  color: #4338ca;
}
.tut-node-eq { border-color: #d1d5db; background: #f9fafb; color: #9ca3af; font-size: 0.6rem; width: 24px; height: 24px; }
.tut-node-var {
  border-color: #a7f3d0; background: linear-gradient(135deg, #ecfdf5, #d1fae5); color: #065f46;
}
.tut-node-op { border-color: #ddd6fe; background: linear-gradient(135deg, #f5f3ff, #ede9fe); color: #7c3aed; font-size: 0.65rem; width: 24px; height: 24px; }
.tut-node-num { border-color: #fde68a; background: linear-gradient(135deg, #fefce8, #fef3c7); color: #92400e; font-family: 'SF Mono', monospace; font-size: 0.5rem; width: auto; min-width: 24px; padding: 0 3px; }
.tut-node-paren { border-color: #d1d5db; background: #f3f4f6; color: #6b7280; font-size: 0.6rem; width: 20px; height: 24px; }
.tut-wire { width: 10px; height: 1.5px; background: #d1d5db; flex-shrink: 0; }
.tut-example-result {
  display: flex; align-items: center; gap: 6px;
  margin-top: 10px; padding: 8px 12px; border-radius: 8px;
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  border: 1px solid #a7f3d0;
  font-size: 0.76rem; color: #059669; font-weight: 600;
}
.tut-example-result strong { color: #047857; }
.tut-example-check { font-size: 0.85rem; }

/* CONTEXT NODES */
.tut-n-ctx { border-color: #c7d2fe; background: linear-gradient(135deg, #eef2ff, #e0e7ff); color: #4f46e5; }

/* RULE DEMO */
.tut-rule-demo {
  background: #fff; border: 1px solid #e5e7eb; border-radius: 10px;
  padding: 16px; margin: 10px 0;
}
.tut-rule-row {
  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
}
.tut-rule-tag {
  padding: 3px 8px; border-radius: 5px; font-size: 0.6rem;
  font-weight: 800; letter-spacing: 0.8px; flex-shrink: 0;
}
.tut-rule-if { background: linear-gradient(135deg, #dbeafe, #eff6ff); color: #3b82f6; }
.tut-rule-then { background: linear-gradient(135deg, #d1fae5, #ecfdf5); color: #059669; }
.tut-rule-pill {
  padding: 5px 10px; border-radius: 6px; font-size: 0.72rem; font-weight: 600;
}
.tut-rule-pill-field { background: #eff6ff; color: #3b82f6; border: 1px solid #bfdbfe; }
.tut-rule-pill-op { background: #f5f3ff; color: #6366f1; border: 1px solid #ddd6fe; }
.tut-rule-pill-val { background: #f9fafb; color: #374151; border: 1px solid #e5e7eb; font-family: 'SF Mono', monospace; }
.tut-rule-pill-var { background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0; }
.tut-rule-pill-override {
  background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0;
  font-family: 'SF Mono', monospace; font-weight: 700; font-size: 0.8rem;
}
.tut-rule-eq { font-size: 0.85rem; font-weight: 700; color: #6366f1; }
.tut-rule-arrow {
  padding: 4px 0; margin-left: 24px; color: #c7d2fe; font-size: 0.7rem;
}

/* TIPS */
.tut-tips { display: flex; flex-direction: column; gap: 8px; }
.tut-tip {
  display: flex; gap: 12px; padding: 10px 12px;
  border-radius: 10px; transition: background 0.15s;
}
.tut-tip:hover { background: #f9fafb; }
.tut-tip-icon {
  width: 34px; height: 34px; border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
  border: 1px solid #c7d2fe; color: #6366f1;
  font-size: 0.75rem; flex-shrink: 0;
}
.tut-tip strong { display: block; font-size: 0.78rem; color: #1f2937; margin-bottom: 2px; }
.tut-tip p { margin: 0; font-size: 0.73rem; color: #6b7280; line-height: 1.45; }
.tut-tip p strong { display: inline; font-size: inherit; }
</style>
